<!--
 * @Description: 应用程序框架页面
 * @Author: laoliu sunhuihong
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <div id="app"><router-view /></div>
</template>
<!-- test -->
<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'App',
  methods: {
  },

  beforeCreate() {
    //清除是否显示未读消息标识
    sessionStorage.removeItem('showNoReadNotify');
  },
  /**
   * @Description: 该函数中包含了通过管理员类型+机构标识登录的处理机制和机构注册的处理机制
   * 管理员处理逻辑:   1 将标识记入SESSION_ADMIN_TYPE和SESSION_IDENTIFIER
   *                 判断是否已登录。如果未登录，自动转登录页面。否则转2
   *                 2 如果当前路径为/，转主页面(如Overview)，否则转当前路径
   * 机构注册处理逻辑:  1 如果当前路径在机构注册页面就保留在此页面
   * @Author: laoliu，wanqian
   * @Date: 2021-02-08 20:45:59
   */
  mounted: async function() {
    if (this.$route.name == 'instadminreg' || this.$route.name == 'instregisterinfo') {
        sessionStorage.setItem(Constant.SESSION_ADMIN_TYPE, 'inst');
        sessionStorage.setItem(Constant.SESSION_IDENTIFIER, Constant.FLAG_INST_SELF_REG);
        return;
    }
    
    let adminType = this.$route.params.adminType ? this.$route.params.adminType : 'global';
    let identifier = this.$route.params.identifier ? this.$route.params.identifier : '';
    sessionStorage.setItem(Constant.SESSION_ADMIN_TYPE, adminType);
    sessionStorage.setItem(Constant.SESSION_IDENTIFIER, identifier);
    
    await this.appAxios("GET", this.commonUrl.URL_IS_LOGGEDIN).then(result => {
      if (result != null) {
        let curPath = this.$route.path == '/' ? result.data : this.$route.path;
        this.$router.push(curPath);
      }
    })
  }
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
/* 解决由于电脑显示的缩放引起的table表格错位 */
body .el-table th.gutter{
    display: table-cell!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue